import * as React from 'react';
import { PresentationError } from 'constants/ErrorTypes';
import EnterPresenterCode from './EnterPresenterCode';
import TogglePresenting from './TogglePresenting';
import HeaderedContent from './HeaderedContent';

// props from Redux Store
export interface StateProps {
  canPresent: boolean;
  isExtensionInstallVisible: boolean;
  isPresenting: boolean;
  isPresenterAuthenticated: boolean;
  presentationError: PresentationError;
  roomName: string;
  submitError: string;
  loggingId: string;
  isAuthenticating: boolean;
}

// props from Actions
export interface DispatchProps {
  onAuthenticationEdit: any;
  onSubmitPresenterCode: any;
  showPresentationSelector: any;
  stopPresenting: any;
}

type Props = StateProps & DispatchProps;

const Home: React.FunctionComponent<Props> = props => {
  const content = () => {
    if (props.isPresenterAuthenticated) {
      return (
        <TogglePresenting
          canPresent={props.canPresent}
          isExtensionInstallVisible={props.isExtensionInstallVisible}
          isPresenting={props.isPresenting}
          presentationError={props.presentationError}
          roomName={props.roomName}
          showPresentationSelector={props.showPresentationSelector}
          stopPresenting={props.stopPresenting}
        />
      );
    }
    return (
      <EnterPresenterCode
        onAuthenticationEdit={props.onAuthenticationEdit}
        onSubmit={props.onSubmitPresenterCode}
        submitError={props.submitError}
        isAuthenticating={props.isAuthenticating}
      />
    );
  };

  return (
    <HeaderedContent isFooterVisible={true} loggingId={props.loggingId} >
      {content()}
    </HeaderedContent>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.tsx